import React from 'react';
import moment from 'moment';
import { View } from 'react-native';
import { useStyleSheet } from '../../../hooks';
import { createStyleSheet } from '../../../utils';
import { useMonth } from '../hooks/useMonth';
import { Day } from './Day';
export const Month = ({ appointments, date, style, selected, onSelect, disabledBefore, disabledAfter, highlighted, size }) => {
    const styles = useStyleSheet(getStyles);
    const { weeks, appointmentsByDay } = useMonth({ date, appointments });
    return (React.createElement(View, { style: [styles.container, style] }, weeks.map((week, index) => (React.createElement(View, { key: index, style: styles.week }, week.map((day) => moment(day).isSame(date, 'month') ? (React.createElement(Day, { appointmentsByDay: appointmentsByDay === null || appointmentsByDay === void 0 ? void 0 : appointmentsByDay[day], key: day, day: day, selected: selected, onSelect: onSelect, disabled: disabledBefore
            ? moment(day).isBefore(disabledBefore, 'day')
            : disabledAfter
                ? moment(day).isAfter(disabledAfter, 'day')
                : undefined, highlighted: highlighted, showAppointments: !!appointments, size: size })) : (React.createElement(View, { key: day, style: styles.placeholder }))))))));
};
const getStyles = createStyleSheet(({ size }) => ({
    container: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        paddingVertical: size.C,
        width: '100%'
    },
    placeholder: {
        height: size.M,
        width: size.M,
        flexGrow: 1,
        flexBasis: 0
    },
    week: {
        width: '100%',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: size.B
    }
}));
//# sourceMappingURL=Month.js.map